window.addEventListener("DOMContentLoaded", () => {
  const subscriptionWidget = document?.querySelector(
    ".shopify_subscriptions_app_block",
  );
  const policy = subscriptionWidget?.querySelector(
    ".shopify_subscriptions_app_policy",
  );
  const subscriptionBlock = subscriptionWidget?.querySelector(
    ".shopify_subscriptions_app_block_label:last-of-type",
  );
  if (policy && subscriptionBlock) {
    subscriptionBlock.appendChild(policy);
  }
});
